import '../App.css'

import { useContext, useEffect, useState, useRef } from 'react';

import { useQuery } from 'graphql-hooks'

import { Header } from '../MainPage/Header'
import { Menu } from '../MainPage/Menu'
import { NoBackImg } from '../Contact/NoBackImg'
import { NewsInfo } from './NewsInfo'
import { NewsText } from './NewsText';
import { NewsRecap } from './NewsRecap';

import MenuContext from '../context/MenuContext';

const HOMEPAGE_QUERY = `query homepage {


allInfos {
  titulo
  fecha
  descripcion
  tipo
  id
}

}`

export const News = () => {
    const { loading, error, data } = useQuery(HOMEPAGE_QUERY, {
        variables: {
            limit: 10
        }
    })


    const { valueMenu, handleFalseMenu } = useContext(MenuContext)
    const [padding, setPadding] = useState()
    const menu = useRef(null)

    useEffect(() => {
        setPadding(menu.current.children[0].clientHeight)
        valueMenu && handleFalseMenu()
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
        // eslint-disable-next-line
    }, [])

    return (
        <div>
            <div className="fixedMenu" ref={menu}>
                <Header />
                <Menu />
            </div>

            <div style={{ paddingTop: padding }}>
                <NoBackImg />
            </div>

            <div>
                <NewsText />
                <NewsRecap data={data} />

                <NewsInfo data={data} loading={loading} error={error} />
            </div>
        </div>

    )
}